export { default } from './components/Icon';


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons-react@1.0.0@@ant-design/icons-react/es/index.js
// module id = 248
// module chunks = 0 1